// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

(function () {
  function prepareOverlay(container, image) {
    if (!container || !image) return;

    // enable zoom
    container.classList.add('image-zoom-inline-full-size');
    container.setAttribute('aria-hidden', 'false');

    // set picture zoom
    container.style.backgroundImage = `url('${image.currentSrc || image.src}')`;
    container.style.backgroundColor = 'var(--color-background)';

    // hide orinal img
    image.style.opacity = '0';
  }

  function clearOverlay(container, image) {
    // disible zoom
    container.classList.remove('image-zoom-inline-full-size');
    container.removeAttribute('aria-hidden');
    container.style.backgroundImage = '';

    // show orginal img
    if (image) image.style.opacity = '';
  }

  document.addEventListener('click', function (e) {
    const media = e.target.closest('.product-media');
    if (!media) return;

    const img = media.querySelector('img');
    if (!img) return;

    // toggle zoom
    if (media.classList.contains('image-zoom-inline-full-size')) {
      clearOverlay(media, img);
    } else {
      prepareOverlay(media, img);
    }
  });
})();
//zoom move to mouse
document.addEventListener('mousemove', function (e) {
  const zoomed = document.querySelector('.image-zoom-inline-full-size');
  if (!zoomed) return;

  const rect = zoomed.getBoundingClientRect();
  const x = ((e.clientX - rect.left) / rect.width) * 100;
  const y = ((e.clientY - rect.top) / rect.height) * 100;

  zoomed.style.backgroundPosition = `${x}% ${y}%`;
});


function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  overlay.onclick = () => overlay.remove();
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-zoom-inline');
  images.forEach((image) => {
    image.onclick = (event) => {
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };
  });
}

enableZoomOnHover(2);
